var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeChair(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 24h-8.5a.75.75 0 0 1 0-1.5h8.5a.75.75 0 0 1 0 1.5zM17.061 13H6.939a1.746 1.746 0 0 1-1.339-.624 1.742 1.742 0 0 1-.385-1.426l1.652-9.5C7.013.61 7.738 0 8.591 0h6.817c.854 0 1.579.61 1.724 1.451l1.652 9.5c.089.51-.051 1.03-.385 1.426-.332.395-.82.623-1.338.623zM8.591 1.5a.25.25 0 0 0-.247.207l-1.652 9.5a.25.25 0 0 0 .246.293H17.06a.244.244 0 0 0 .191-.089.248.248 0 0 0 .055-.204l-1.652-9.5a.247.247 0 0 0-.245-.207z",
    fill: "currentColor",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v4.5A.75.75 0 0 1 12 24z",
    fill: "currentColor",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 19.5H4.75a.75.75 0 0 1-.75-.75v-2A2.752 2.752 0 0 1 6.75 14h10.5A2.752 2.752 0 0 1 20 16.75v2a.75.75 0 0 1-.75.75zM5.5 18h13v-1.25c0-.689-.561-1.25-1.25-1.25H6.75c-.689 0-1.25.561-1.25 1.25z",
    fill: "currentColor",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 18.25a.75.75 0 0 1-.75-.75v-3a2.752 2.752 0 0 1 2.75-2.75.75.75 0 0 1 0 1.5c-.689 0-1.25.561-1.25 1.25v3a.75.75 0 0 1-.75.75zM4.75 18.25A.75.75 0 0 1 4 17.5v-3c0-.689-.561-1.25-1.25-1.25a.75.75 0 0 1 0-1.5A2.752 2.752 0 0 1 5.5 14.5v3a.75.75 0 0 1-.75.75z",
    fill: "currentColor",
    opacity: 1,
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeChair);
export default __webpack_public_path__ + "static/media/office-chair.d5522c886c0b9ca1c88a6854653b2609.svg";
export { ForwardRef as ReactComponent };